// extracted by mini-css-extract-plugin
export default {"container":"clientsFilter_container__C0qIm"};